import React, { useEffect, useState } from "react";
import styles from "./SettingsModal.module.css";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";

interface Props {
  onClose: () => void;
}

const SettingsModal: React.FC<Props> = ({ onClose }) => {
  const [otpEnabled, setOtpEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res: any = await WebService.getAPI({
          action: "/v1/door-management/settings/otp-login",
          isShowError: false,
        });
        if (mounted) {
          const enabled = res?.data?.otp_login_enabled;
          setOtpEnabled(enabled !== false && enabled !== "false");
        }
      } catch {
        if (mounted) toast.error("Failed to load settings");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleToggle = async () => {
    const next = !otpEnabled;
    setSaving(true);
    try {
      const res: any = await WebService.putAPI({
        action: "/v1/door-management/settings/otp-login",
        body: { otp_login_enabled: next },
        isShowError: false,
      });
      if (res?.status_code === 200) {
        setOtpEnabled(next);
        toast.success(
          next
            ? "OTP login enabled for all users"
            : "OTP login disabled — users can log in with password only"
        );
      } else {
        toast.error(res?.message || "Failed to update setting");
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update setting");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <span>Settings</span>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        {loading ? (
          <div className={styles.loading}>Loading settings…</div>
        ) : (
          <div className={styles.row}>
            <div className={styles.rowText}>
              <div className={styles.rowTitle}>OTP Login</div>
              <div className={styles.rowHint}>
                {otpEnabled
                  ? "OTP verification is required for all users during login."
                  : "Users can log in with mobile and password only (no OTP)."}
              </div>
            </div>
            <button
              type="button"
              className={`${styles.toggle} ${otpEnabled ? styles.toggleOn : ""}`}
              onClick={handleToggle}
              disabled={saving}
              aria-pressed={otpEnabled}
              aria-label="Toggle OTP login"
            >
              <span className={styles.toggleKnob} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsModal;
